/*
 * 该券包活动页为一次性页面 pm @刁鹏
 * 为了能在墨西哥快速验证活动效果，没有做通用模板的设计
 * pm定的，该页面的所有元素和金额均为写死，但券包的总价格price和productId为服务端下发
 *
*/
<template>
  <div class="activity-wrap">
    <header>
      <img class="activity-bg" src="@/assets/images/c/activity-bg.png" alt="">
    </header>
    <main>
      <h2 class="title">{{gettext("轻松来获得一个非常棒的优惠券包")}}</h2>
      <p class="text-explain">
        <span>{{gettext("购买含4张$10mxn无门槛券的优惠券包仅需支付$20mxn")}}</span>
      </p>
      <div class="coupon-list">
        <div class="coupon">$10</div>
        <div class="coupon">$10</div>
        <div class="coupon">$10</div>
        <div class="coupon">$10</div>
      </div>
      <ul class="activity-rule">
        <li>{{gettext("在购买后的一个月内都可以使用")}}</li>
        <li>{{gettext("在您的订单中使用这些优惠！")}}</li>
      </ul>
    </main>
    <footer>
      <div class="btn-buy" @click="handleClick">
        {{btnText}}
      </div>
    </footer>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { getScheme, checkIsOldVersion } from '@/common/js/utils'
import { Dialog, Locale } from '@didi/rich-ui'
import { DOWNLOAD_URL } from '@/common/js/app-store-link'
import { util } from '@didi/soda-common'
import { getLanguageLong } from '@didi/gettext'
Vue.use(Dialog)
Vue.use(Locale)
const currentLang = getLanguageLong()
Locale.use(currentLang, require(`@didi/rich-ui/lib/locale/lang/${currentLang}`))

const { env } = util
export default {
  name: 'activity',
  data () {
    return {
      productInfo: {},
      position: {},
      cityId: null,
      isSupport: true
    }
  },
  computed: {
    ...mapGetters(['globalParams']),
    btnText () {
      if (this.productInfo.canPurchase === 0) {
        return this.gettext('去预订食物')
      } else if (this.productInfo.canPurchase === 1) {
        return this.gettext('在这里购买！')
      } else {
        return ''
      }
    }
  },
  async created () {
    this.pageInit()
  },
  methods: {
    ...mapActions({
      getProductList: 'getProductList',
      getGlobalInfo: 'getGlobalInfo'
    }),
    handleClick () {
      // canPurchase为1时可以购买跳转至活动页，非1时不可购买，跳转至首页
      if (this.isSupport) {
        if (String(this.productInfo.canPurchase) === '1') {
          this.$router.push({
            path: `/c/coupon/buy`,
            query: {
              productId: this.productInfo.productId,
              price: this.productInfo.price,
              priceDisplay: this.productInfo.priceSplit && this.productInfo.priceSplit.display
            }
          })
        } else if (String(this.productInfo.canPurchase) === '0') {
          location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
        }
      } else {
        this.$createDialog({
          type: 'confirm',
          content: this.gettext('请您升级到最新的APP版本，体验外卖功能'),
          confirmBtn: {
            text: this.gettext('去升级'),
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: this.gettext('知道了'),
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            if (env.isIOS) {
              // ios使用bridge打开应用商店
              this.SodaBridge('openPage', {
                target: 'native',
                url: !env.inSoda ? DOWNLOAD_URL.global : DOWNLOAD_URL.sodaCustomer
              })
            } else {
              location.href = !env.inSoda ? DOWNLOAD_URL.global : DOWNLOAD_URL.sodaCustomer
            }
          }
        }).show()
      }
    },
    pageInit () {
      // 获取公参
      this.getGlobalInfo().then((data) => {
        this.fetchActivityInfo(data)

        const { appVersion } = data
        let clientVersion = null // 独立端 or 嵌入端版本号

        if (!env.inSoda) {
          clientVersion = '7.1.74'
        } else {
          clientVersion = '1.1.4'
        }

        // 独立端1.1.4以下版本，嵌入端7.1.56以下版本的不支持购买券包，因为绑卡和支付有使用新增bridge方法
        if (checkIsOldVersion(appVersion, clientVersion)) {
          this.isSupport = false
        } else {
          this.isSupport = true
        }
      })
    },
    async fetchActivityInfo (data) {
      const res = await this.getProductList({
        ...data,
        shopId: this.params.shopId || 0
      })

      if (res && res.errno === 0) {
        if (Object.keys(res.data).length > 0) {
          // 权益活动为list格式，但是本期只会有一个活动。所以只取第一项
          this.productInfo = res.data.productList && res.data.productList.length > 0 && res.data.productList[0]
        } else {
          const toast = this.$createToast({
            txt: this.gettext('当前无活动'),
            time: 2000,
            type: 'error',
            mask: false
          })
          toast.show()
        }
      } else {
        const errorToast = this.$createToast({
          txt: (res && res.errmsg) || this.gettext('网络繁忙，请稍后再试'),
          time: 2000,
          mask: false,
          type: 'error'
        })
        errorToast.show()
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/common/stylus/variables'
.activity-wrap {
  position: relative;
  padding-bottom: 150px;
  background: #fff;
  header {
    .activity-bg {
      width: 100%;
      height: 550px;
    }
  }
  main {
    margin-top: 20px;
    .title {
      width: 70%;
      margin: 0 auto;
      text-align: center;
      font-size: 46px;
      font-weight: 900;
      color: #F04E98;
      word-break: normal;
    }
    .text-explain {
      width: 95%;
      font-size: 30px;
      line-height: 48px;
      margin: 30px auto;
      text-align: center;
      word-break: normal;
      color: #827c7c;
      b {
        font-weight: bold;
      }
    }
    .coupon-list {
      display: flex;
      justify-content: center;
      .coupon {
        margin: 0 10px;
        padding-left: 40px;
        width: 155px;
        height: 100px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 36px;
        line-height: 100px;
        background-repeat: no-repeat;
        &:nth-child(1) {
          background-image: url("~@/assets/images/c/coupon-bg-yellow.png")
          background-size: 100%;
          color: #ee7038;
        }
        &:nth-child(2) {
          background-image: url("~@/assets/images/c/coupon-bg-purple.png")
          background-size: 100%;
          color: #fff;
        }
        &:nth-child(3) {
          background-image: url("~@/assets/images/c/coupon-bg-orange.png")
          background-size: 100%;
          color: #fadd4a;
        }
        &:nth-child(4) {
          background-image: url("~@/assets/images/c/coupon-bg-yellow.png")
          background-size: 100%;
          color: #ee7038;
        }
      }
    }
    .activity-rule {
      width: 87%;
      margin: 50px auto 30px;
      li {
        position: relative;
        padding-left: 35px;
        padding-bottom: 30px;
        font-size: 30px;
        line-height: 48px;
        word-break: normal;
        color: #827c7c;
        &:before {
          position: absolute;
          top: 16px;
          left: 5px;
          content: "";
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #F04E98;
          display: block;
        }
      }
    }
  }
  footer {
    position: fixed;
    bottom: 3%;
    width: 100%;
    margin: 5.5% auto 0;
    .btn-buy {
      width: 85%;
      margin: 0 auto;
      text-align: center;
      height: 90px;
      line-height: 90px;
      border-radius: 10px;
      font-size: 34px;
      color: #fff;
      background: #F04E98;
    }
  }
}
</style>
